import {NgModule} from '@angular/core';
import {CommonModule, DecimalPipe, TitleCasePipe} from '@angular/common';
import {NbModule} from './modules/nb.module';
import {ThemeModule} from '../@theme/theme.module';
import {NgMaterialTableComponent} from './utils/ng-material-table/ng-material-table.component';
import {AngularMaterialModule} from './modules/angular-material.module';
import {DataPropertyGetterPipe} from './pipes/data-property-getter.pipe';
import {RouterLink} from '@angular/router';
import {FormInputComponent} from './utils/ng-material-form/form-input/form-input.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgMaterialFormComponent} from './utils/ng-material-form/ng-material-form.component';
import {FlexModule} from '@angular/flex-layout';
import {MessageService} from './services/message.service';
import {DialogUtilService} from './utils/dialog-util/dialog-util.service';
import {DialogConfirmComponent} from './utils/dialog-util/dialog-confirm/dialog-confirm.component';
import {SnackBarService} from './utils/ng-material-snackbar/snackbar.service';
import {SnackbarComponent} from './utils/ng-material-snackbar/snackbar/snackbar.components';
import {NgMaterialFilterComponent} from './utils/ng-material-filter/ng-material-filter.component';
import {NgMaterialSingleFormComponent} from './utils/ng-material-single-form/ng-material-single-form.component';
import {FormToObjectUtilService} from './utils/form-to-object-util/form-to-object-util.service';
import {FileUploadUtilComponent} from './utils/file-upload-util/file-upload-util.component';
import {PasswordValidator} from './validator/password.validator';
import {DialogMerchantComponent} from './utils/dialog-util/dialog-merchant/dialog-merchant.component';
import {NgMaterialFormService} from './utils/ng-material-form/service/ng-material-form.service';
import {NgApexchartsModule} from 'ng-apexcharts';
import {ExcelUtilService} from './utils/export-util/excel-util.service';
import {AuthService} from '../auth/auth.service';
import {AlignRightNumberDirective} from './directives/align-right-number.directive';
import {DocumentInfoUtilComponent} from './utils/document-info-util/document-info-util.component';
import {MerchantSelectionUtilComponent} from './utils/merchant-selection-util/merchant-selection-util.component';
import {MatSelect} from '@angular/material/select';
import {ExportAsModule} from 'ngx-export-as';
import {BreadcrumbUtilComponent} from './utils/breadcrumb-util/breadcrumb-util.component';
import {BreadcrumbUtilService} from './utils/breadcrumb-util/breadcrumb-util.service';
import {PageStateService} from './services/page-state.service';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import {NgxBarcodeModule} from 'ngx-barcode';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {UploadProgressPopupComponent} from './utils/upload-progress-popup/upload-progress-popup.component';
import {UploadProgressService} from './utils/upload-progress-popup/upload-progress.service';

@NgModule({
  declarations: [
    NgMaterialTableComponent,
    NgMaterialFormComponent,
    FormInputComponent,
    DataPropertyGetterPipe,
    DialogConfirmComponent,
    SnackbarComponent,
    NgMaterialFilterComponent,
    NgMaterialSingleFormComponent,
    FileUploadUtilComponent,
    DialogMerchantComponent,
    AlignRightNumberDirective,
    DocumentInfoUtilComponent,
    MerchantSelectionUtilComponent,
    BreadcrumbUtilComponent,
    UploadProgressPopupComponent,
  ],
  imports: [
    CommonModule,
    NbModule,
    ThemeModule,
    AngularMaterialModule,
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    FlexModule,
    NgApexchartsModule,
    ExportAsModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMaterialTimepickerModule,
    NgxMatNativeDateModule,
    NgxBarcodeModule,
  ],
  exports: [
    NbModule,
    ThemeModule,
    AngularMaterialModule,
    NgMaterialTableComponent,
    NgMaterialFormComponent,
    NgMaterialSingleFormComponent,
    FormsModule,
    ReactiveFormsModule,
    FlexModule,
    NgMaterialFilterComponent,
    FileUploadUtilComponent,
    NgApexchartsModule,
    AlignRightNumberDirective,
    DocumentInfoUtilComponent,
    MerchantSelectionUtilComponent,
    BreadcrumbUtilComponent,
    FormInputComponent,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
  ],
  providers: [
    MessageService,
    DialogUtilService,
    SnackBarService,
    FormToObjectUtilService,
    PasswordValidator,
    NgMaterialFormService,
    ExcelUtilService,
    AuthService,
    TitleCasePipe,
    MatSelect,
    DecimalPipe,
    BreadcrumbUtilService,
    PageStateService,
    UploadProgressService,
  ],
})
export class SharedModule {}
